import React from 'react';
import { connect } from 'react-redux';
import {lineChartOptions, chartDataVertical} from '../../chart/config';
import CsvDownload from '../CsvDownload';
import { Table, Button } from 'antd';
import {makeObjtoArrayTableData, groupReturnedObject} from '../../chart/config'
import {getDataOfTable, capitalizeFirstLetter} from '../../utils/utils';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import numeral from 'numeral';

class MainContent extends React.Component {
    state = {
        sortedInfo: null,
      };
    
      handleChange = (pagination, filters, sorter) => {
        //console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          sortedInfo: sorter,
        });
      }
    
      clearAll = () => {
        this.setState({
          sortedInfo: null,
        });
      }
    render () {
        const vertical = this.props.isVertical === true ? 'vertical' : ''
        const table = this.props.populationForecast.table
        const tableDetails = getDataOfTable(this.props.populationForecast.tables, table)
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        let columns;
        if (table === 'pf_householdnumber') {
            columns = [
                {
                    title: capitalizeFirstLetter(this.props.mainRow),
                    dataIndex: this.props.mainRow,
                    key: this.props.mainRow,
                    sorter: (a, b) => {
                        return numeral(a[this.props.mainRow]).value() - numeral(b[this.props.mainRow]).value()
                    },
                    sortOrder: sortedInfo.columnKey === this.props.mainRow && sortedInfo.order,
                    
                }, {
                    title: 'Group households',
                    dataIndex: 'Group households',
                    key: 'Group households',
                    sorter: (a, b) => {
                        return numeral(a['Group households']).value() - numeral(b['Group households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Group households' && sortedInfo.order,
                    className: 'red-6'
                },{
                    title: 'Lone person households',
                    dataIndex: 'Lone person households',
                    key: 'Lone person households',
                    sorter: (a, b) => {
                        return numeral(a['Lone person households']).value() - numeral(b['Lone person households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Lone person households' && sortedInfo.order,
                    className: 'gold-6'
                },
                {
                    title: 'Multiple-family households',
                    dataIndex: 'Multiple-family households',
                    key: 'Multiple-family households',
                    sorter: (a, b) => {
                        return numeral(a['Multiple-family households']).value() - numeral(b['Multiple-family households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Multiple-family households' && sortedInfo.order,
                    className: 'lime-6'
                },
                {
                    title: 'Single-family households (Couple with children)',
                    width: 200,
                    dataIndex: 'Single-family households (Couple with children)',
                    key: 'Single-family households (Couple with children)',
                    sorter: (a, b) => {
                        return numeral(a['Single-family households (Couple with children)']).value() - numeral(b['Single-family households (Couple with children)']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Single-family households (Couple with children)' && sortedInfo.order,
                    className: 'magenta-6'
                },

                
                {
                    title: 'Single-family households (Couple without children)',
                    width: 220,
                    dataIndex: 'Single-family households (Couple without children)',
                    key: 'Single-family households (Couple without children)',
                    sorter: (a, b) => {
                        return numeral(a['Single-family households (Couple without children)']).value() - numeral(b['Single-family households (Couple without children)']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Single-family households (Couple without children)' && sortedInfo.order,
                    className: 'cyan-6'
                }
                ,
                {
                    title: 'Single-family households (Other family households)',
                    width: 220,
                    dataIndex: 'Single-family households (Other family households)',
                    key: 'Single-family households (Other family households)',
                    sorter: (a, b) => {
                        return numeral(a['Single-family households (Other family households)']).value() - numeral(b['Single-family households (Other family households)']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Single-family households (Other family households)' && sortedInfo.order,
                    className: 'blue-6'
                }
                ,
                {
                    title: 'Single-family households (Single parent)',
                    width: 200,
                    dataIndex: 'Single-family households (Single parent)',
                    key: 'Single-family households (Single parent)',
                    sorter: (a, b) => {
                        return numeral(a['Single-family households (Single parent)']).value() - numeral(b['Single-family households (Single parent)']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Single-family households (Single parent)' && sortedInfo.order,
                    className: 'purple-6'
                }
            ];
        }  else if (table === 'pf_householdsize') {
            columns = [
                {
                    title: capitalizeFirstLetter(this.props.mainRow),
                    dataIndex: this.props.mainRow,
                    key: this.props.mainRow,
                    sorter: (a, b) => {
                        return numeral(a[this.props.mainRow]).value() - numeral(b[this.props.mainRow]).value()
                    },
                    sortOrder: sortedInfo.columnKey === this.props.mainRow && sortedInfo.order,
                    width: 80,
                }, {
                    title: 'All households',
                    dataIndex: 'All households',
                    key: 'All households',
                    sorter: (a, b) => {
                        return numeral(a['All households']).value() - numeral(b['All households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'All households' && sortedInfo.order,
                    className: 'red-6',
                    width: 120,
                },{
                    title: 'Family households',
                    dataIndex: 'Family households',
                    key: 'Family households',
                    sorter: (a, b) => {
                        return numeral(a['Family households']).value() - numeral(b['Family households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Family households' && sortedInfo.order,
                    className: 'gold-6',
                    width: 120,
                },
                {
                    title: 'Lone person households',
                    dataIndex: 'Lone person households',
                    key: 'Lone person households',
                    sorter: (a, b) => {
                        return numeral(a['Lone person households']).value() - numeral(b['Lone person households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Lone person households' && sortedInfo.order,
                    className: 'lime-6'
                },
                {
                    title: 'Group households',
                    width: 120,
                    dataIndex: 'Group households',
                    key: 'Group households',
                    sorter: (a, b) => {
                        return numeral(a['Group households']).value() - numeral(b['Group households']).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Group households' && sortedInfo.order,
                    className: 'magenta-6'
                },
                
            
            ];
        } else {
            columns = [
                {
                    title: capitalizeFirstLetter(this.props.mainRow),
                    dataIndex: this.props.mainRow,
                    key: this.props.mainRow,
                    sorter: (a, b) => {
                        return numeral(a[this.props.mainRow]).value() - numeral(b[this.props.mainRow]).value()
                    },
                    sortOrder: sortedInfo.columnKey === this.props.mainRow && sortedInfo.order,
                }, {
                    title: 'Males',
                    dataIndex: 'Males',
                    key: 'Males',
                    sorter: (a, b) => {
                        return numeral(a.Males).value() - numeral(b.Males).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Males' && sortedInfo.order,
                },{
                    title: 'Females',
                    dataIndex: 'Females',
                    key: 'Females',
                    sorter: (a, b) => {
                        return numeral(a.Females).value() - numeral(b.Females).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Females' && sortedInfo.order,
                },
                {
                    title: 'Persons',
                    dataIndex: 'Persons',
                    key: 'Persons',
                    sorter: (a, b) => {
                        return numeral(a.Persons).value() - numeral(b.Persons).value()
                    },
                    sortOrder: sortedInfo.columnKey === 'Persons' && sortedInfo.order,
                }];
        }



        return (
            <div className="population-forecast-content-container">
            <h1>Population Forecast </h1>
            <div className="population-forecast-slider">
                {this.props.slider()}
            </div>
            <div className={`population-forecast-content ${vertical}`}>
           
                <div className="population-forecast-chart">
                    {this.props.render()}
                </div>
                <div className="population-forecast-table">
                    <Table 

                    bordered={true} rowKey={record => record.Group} pagination={false} dataSource={this.props.tableData} 
                    columns={columns} onChange={this.handleChange} />
                </div>
            </div>
            <div className="population-forcast-explaination tab">
                <h3 className="tab__header">{tableDetails.summary_heading}</h3>
                <div className="tab__content full">
                <div>{ReactHtmlParser(tableDetails.about_text)}</div>
                </div>
            </div>
        </div>
        )
    }
}

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/populationForecast/MainContent.js